import { Fragment, useEffect } from "react";
import React from "react";
import {
    Card,
    CardContent,
    CardActions,
    Typography,
    Button,
    Grid,
    Box,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import PersonIcon from "@mui/icons-material/Person";
import { useDispatch, useSelector } from "react-redux";
import { ActualizarCartera, actualizarCliente, agregarCartera, obtenerCarteraConAsociados, obtenerCarteraConClientes, obtenerCarteraConEjecutivo } from "../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck";
import Swal from "sweetalert2";
function CarterasComponent() {
    const primaryColor = "#CD973D";
    const dispatch = useDispatch()
    let carteras = useSelector(store => store.UsuariosAtencionACliente.carteras)

    useEffect(() => {
        dispatch(obtenerCarteraConEjecutivo())
    }, [])

    const carterasOrdenadas = [...carteras].sort((a, b) => {
        if (a.estatus && !b.estatus) return -1;
        if (!a.estatus && b.estatus) return 1;

        const rolA = a.datoslogin[0]?.login?.[0]?.idrol || 0;
        const rolB = b.datoslogin[0]?.login?.[0]?.idrol || 0;
        return rolA - rolB; // ascendente
    });
    const btnEditar = async (cartera) => {
        Swal.fire({
            title: "Editar Cartera",
            html: `
            <style>
              .floating-label {
                position: relative;
                width: 100%;
              }
              .floating-label input {
                width: 100%;
                padding: 12px 10px 8px;
                border: 1px solid #ccc;
                border-radius: 6px;
                outline: none;
                transition: all 0.2s ease;
                background: transparent;
              }
              .floating-label label {
                position: absolute;
                top: 12px;
                left: 12px;
                color: #888;
                background: white;
                padding: 0 5px;
                font-size: 14px;
                transition: 0.2s ease all;
                pointer-events: none;
              }
              .floating-label input:focus + label,
              .floating-label input:not(:placeholder-shown) + label {
                top: -8px;
                left: 10px;
                font-size: 12px;
                color: #CD973D;
                font-weight: bold;
              }
            </style>
      
            <div style="display: flex; flex-direction: column; gap: 20px; text-align: left;">
              <div class="floating-label">
                <input 
                  id="nombreCartera"
                  type="text"
                  placeholder=" "
                  value="${cartera.nombrecartera || ''}"
                />
                <label for="nombreCartera">Nombre de Cartera</label>
              </div>
      
              <label style="display: flex; align-items: center; gap: 8px; margin-top: 10px;">
                <input id="estatusCartera" type="checkbox" ${cartera.estatus ? "checked" : ""}>
                <span>Activo</span>
              </label>
            </div>
          `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonText: "Cancelar",
            preConfirm: () => {
                const nombre = document.getElementById("nombreCartera").value;
                const estatus = document.getElementById("estatusCartera").checked;

                if (!nombre) {
                    Swal.showValidationMessage("Por favor ingrese un nombre");
                    return false;
                }

                return { nombre, estatus };
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                const { nombre, estatus } = result.value;

                if (!estatus) {
                    const { value: nuevoEjecutivo } = await Swal.fire({
                        title: "Asignar nuevo ejecutivo",
                        html: `
                            <p><b>Nota:</b>Esta cartera será desactivada. Debe seleccionar una nueva cartera que se hará cargo de los socios.</p>
                            <select id="nuevoEjecutivo" class="swal2-select" style="width:80%;padding:8px;border-radius:6px;">
                                <option value="">Seleccione una nueva cartera</option>
                                ${carteras.map((cartera) => `<option value="${cartera.idcartera}">${cartera.nombrecartera}</option>`).join("")}
                            </select>
                            `,
                        showCancelButton: true,
                        confirmButtonText: "Confirmar",
                        cancelButtonText: "Cancelar",
                        preConfirm: () => {
                            const select = document.getElementById("nuevoEjecutivo");
                            if (!select.value) {
                                Swal.showValidationMessage("Debe seleccionar un ejecutivo");
                                return false;
                            }
                            return select.value;
                        },
                    });

                    if (!nuevoEjecutivo) {
                        Swal.fire("Operación cancelada", "", "info");
                        return;
                    }

                    let clientes = await dispatch(obtenerCarteraConClientes(Number(cartera.idcartera)))
                    let dataClientes = { clientes: clientes?.payload?.[0]?.cliente, idcartera: nuevoEjecutivo }
                    await dispatch(actualizarCliente(dataClientes))
                    Swal.fire({
                        icon: "success",
                        title: "Cartera desactivada",
                        text: `Se reasignó al ejecutivo con ID ${nuevoEjecutivo}`,
                    });
                }

                let data = { idcartera: cartera.idcartera, nombrecartera: nombre, estatus }
                await dispatch(ActualizarCartera(data))
                Swal.fire({
                    icon: "success",
                    title: "Cartera actualizada",
                    text: `Nombre: ${nombre}\nEstatus: Activo`,
                });
                await dispatch(obtenerCarteraConEjecutivo())
            }
        });
    };
    const handleAgregarCartera = async () => {
        const { value: nombreCartera } = await Swal.fire({
            title: "Agregar Nueva Cartera",
            html: `
            <input
              type="text"
              id="nombreCartera"
              class="swal2-input"
              placeholder="Nombre de la cartera"
            >
          `,
            confirmButtonText: "Guardar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            focusConfirm: false,
            preConfirm: () => {
                const input = document.getElementById("nombreCartera").value.trim();
                if (!input) {
                    Swal.showValidationMessage("Debes ingresar un nombre");
                    return false;
                }
                return input;
            },
        });

        if (nombreCartera) {
            let carteraData = { nombrecartera: nombreCartera, estatus: true }
            await dispatch(agregarCartera(carteraData))
        }
        Swal.fire("¡Cartera creada!", `Se agregó "${nombreCartera}" correctamente.`, "success");
        await dispatch(obtenerCarteraConEjecutivo())
    }

    return (
        <Fragment >
            <div className="container">
                <Box
                    sx={{
                        minHeight: "100vh",
                        backgroundColor: "#f5f5f5",
                        color: "#333",
                        p: 4,
                        borderRadius: '5%'
                    }}
                >
                    <Typography
                        variant="h4"
                        align="center"
                        sx={{ mb: 1, fontWeight: "bold" }}
                    >
                        Panel de Carteras
                    </Typography>
                    <Typography align="center" sx={{ mb: 6, color: "#666" }}>
                        Visualiza las carteras y sus ejecutivos
                    </Typography>
                    <Box textAlign="end" sx={{ mb: 5, marginTop: '-5%' }}>
                        <Button
                            variant="contained"
                            onClick={handleAgregarCartera}
                            sx={{
                                backgroundColor: primaryColor,
                                color: "#fff",
                                borderRadius: "10px",
                                fontWeight: "bold",
                                "&:hover": { backgroundColor: "#b77e2f" },
                            }}
                        >
                            ➕ Agregar Cartera
                        </Button>
                    </Box>

                    <Grid container spacing={4} justifyContent="center">
                        {carterasOrdenadas.map((cartera) =>
                            cartera.estatus == true && (
                                <Grid item key={cartera.idcartera} xs={12} sm={6} md={4} lg={3}>
                                    <Card
                                        sx={{
                                            backgroundColor: cartera.estatus ? "#fff" : "#f0f0f0", // fondo según estatus
                                            border: `2px solid ${cartera.estatus ? primaryColor + "33" : "#ccc"}`,
                                            borderRadius: "16px",
                                            boxShadow: cartera.estatus
                                                ? "0 4px 12px rgba(0,0,0,0.08)"
                                                : "0 2px 6px rgba(0,0,0,0.05)",
                                            transition: "all 0.3s ease",
                                            "&:hover": {
                                                transform: "scale(1.03)",
                                                border: `2px solid ${cartera.estatus ? primaryColor : "#FF0000"}`,
                                                boxShadow: cartera.estatus
                                                    ? `0 6px 20px ${primaryColor}33`
                                                    : "0 4px 12px rgba(0,0,0,0.08)",
                                            },
                                        }}
                                    >
                                        <CardContent>
                                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                <Box display="flex" alignItems="center">
                                                    <WorkIcon sx={{ color: primaryColor, mr: 1 }} />
                                                    <Typography
                                                        variant="h6"
                                                        sx={{ fontWeight: "bold", color: "#333" }}
                                                    >
                                                        {cartera.nombrecartera}
                                                    </Typography>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        width: 16,
                                                        height: 16,
                                                        borderRadius: "50%",
                                                        backgroundColor: cartera.estatus ? "green" : "red",
                                                    }}
                                                />
                                            </Box>

                                            <Box display="flex" alignItems="center">
                                                <PersonIcon sx={{ color: primaryColor, mr: 1 }} />
                                                <Typography sx={{ color: "#666" }}>
                                                    {cartera.datoslogin[0]?.login?.[0]?.idrol == 1 ? 'Jefe' : 'Ejecutivo'}: {(cartera.datoslogin?.[0]?.nombre || '') + ' ' + (cartera.datoslogin?.[0]?.apellidos || '')}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                        <CardActions>
                                            {cartera?.estatus &&
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    sx={{
                                                        backgroundColor: primaryColor,
                                                        color: "#fff",
                                                        fontWeight: "bold",
                                                        borderRadius: "10px",
                                                        "&:hover": {
                                                            backgroundColor: "#b77e2f",
                                                            boxShadow: `0 0 10px ${primaryColor}55`,
                                                        },
                                                    }}
                                                    onClick={() => btnEditar(cartera)}
                                                >
                                                    Editar
                                                </Button>

                                            }

                                        </CardActions>
                                    </Card>
                                </Grid>
                            )
                        )}
                    </Grid>
                </Box>
            </div>
        </Fragment>
    );
}

export default CarterasComponent;